export const floatingAlertStyles = {
	floatingAlert: {
		position: 'fixed',
		top: '20px',
		right: '20px',
		display: 'flex',
		alignItems: 'center',
		backgroundColor: 'colors.dark4',
		border: '1px solid colors.dark1',
		borderRadius: '4px',
		padding: '10px',
		zIndex: '1999',
		gap: '10px',
	},
	alertText: {
		flexGrow: 1,
		marginRight: '10px',
	},
	alertDismiss: {
		cursor: 'pointer',
		padding: '5px 10px',
	},
	updateButton: {
		padding: '4px 16px',
		borderRadius: '4px',
		color: 'colors.light2',
		backgroundColor: 'colors.dark3',
		textTransform: 'none',
		alignSelf: 'center',

		'&:hover': {
			backgroundColor: 'colors.dark4',
		},
	},
};
